import { useTranslation } from 'react-i18next';

import { formatISOString } from 'utils/date';

import { Box, Table, TableBody, TableCell, TableRow } from '@mui/material';

import { Tooltip } from 'components/shared';
import { PeriodAssignmentResponse } from 'generated/index';

type Props = {
  row: PeriodAssignmentResponse;
};

function PeriodAssignmentStatusToolTipBody({ row }: Props) {
  const { t } = useTranslation();
  return (
    <Table size="small">
      <TableBody>
        {row.requestedOn && (
          <TableRow>
            <TableCell>
              {t('requestedOn')} {formatISOString(row.requestedOn)}{' '}
              {t('by').toLowerCase()} {row.requestedBy ?? ''}
            </TableCell>
          </TableRow>
        )}
        {row.inProgressOn && (
          <TableRow>
            <TableCell>
              {t('inProgressOn')} {formatISOString(row.inProgressOn)}{' '}
              {t('by').toLowerCase()} {row.inProgressBy ?? ''}
            </TableCell>
          </TableRow>
        )}
        {row.completedOn && (
          <TableRow>
            <TableCell>
              {t('completedOn')} {formatISOString(row.completedOn)}{' '}
              {t('by').toLowerCase()} {row.completedBy ?? ''}
            </TableCell>
          </TableRow>
        )}
        {row.returnedOn && (
          <>
            <TableRow>
              <TableCell sx={{ border: 0 }}>
                {t('returnedOn')} {formatISOString(row.returnedOn)}{' '}
                {t('by').toLowerCase()} {row.returnedBy ?? ''}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ border: 0 }}>{row.reason ?? ''}</TableCell>
            </TableRow>
          </>
        )}
      </TableBody>
    </Table>
  );
}

const AssignmentStatusInformation = ({ row }: Props) => {
  const { t } = useTranslation();

  let dateInfo;

  switch (row.status.toLowerCase()) {
    case t('completed').toLowerCase():
      dateInfo = row.completedOn
        ? `${t('on')} ${formatISOString(row.completedOn)}`
        : '';
      break;
    case t('returned').toLowerCase():
      dateInfo = row.returnedOn
        ? `${t('on')} ${formatISOString(row.returnedOn)}`
        : '';
      break;
    case t('in_progress').toLowerCase():
      dateInfo = row.inProgressOn
        ? `${t('on')} ${formatISOString(row.inProgressOn)}`
        : '';
      break;
    default:
      dateInfo = row.requestedOn
        ? `${t('on')} ${formatISOString(row.requestedOn)}`
        : '';
      break;
  }

  return (
    <Box display="flex" flexDirection="column">
      <Tooltip title={<PeriodAssignmentStatusToolTipBody row={row} />} arrow>
        <span>{row.status}</span>
      </Tooltip>
      <span style={{ fontSize: '80%', fontFamily: 'signikalight' }}>
        {dateInfo}
      </span>
    </Box>
  );
};

export default AssignmentStatusInformation;
